import { BundleType } from 'swag-common/constants/main-swag.constants';
export function getBundleTypeBasedOnResellerSettings() {
  if (window.swag && window.swag.storeSettings) {
    // potentially we can put value of bundleType into store setting if we want to make it more customizable;
    return BundleType.DYNAMIC;
  }
  return null;
}